<div class="container px-0 py-4 mx-0" style="height:100%">
    <div class="row" style="height:100%">
        <div class="col-md-3" style="text-align: center;">
            <mat-card style="border: 1px solid #ECECEC;border-radius: 12px;box-shadow: none;">
                <div *ngFor="let bot of allBotDetails; let i=index;">
                    <div class="px-4">
                        <label (click)="getBotDetails(bot.bot_id, i)" 
                        [ngClass]="activeBot.bot_id== bot.bot_id ? 'bot-name-active' : 'bot-name '"
                            class="py-4 bot-name-active">{{bot.configuration.name}}</label>
                        <div style="border-bottom: 1px solid #e9e9e9;"></div>
                    </div>
                </div>
            </mat-card>
        </div>
        <div class="col">
            <div class="row py-2">
                <mat-card style="box-shadow: none;">
                    <label class="field-title">Verification Status</label>
                    <div class="py-1">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle opacity="0.1" cx="12" cy="12" r="12" fill="#F8B200" />
                            <path
                                d="M11.9453 17.1367C14.7067 17.1367 16.9453 14.8981 16.9453 12.1367C16.9453 9.37529 14.7067 7.13672 11.9453 7.13672C9.18389 7.13672 6.94531 9.37529 6.94531 12.1367C6.94531 14.8981 9.18389 17.1367 11.9453 17.1367Z"
                                stroke="#F8B200" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M11.9453 9.13672V12.1367L13.9453 13.1367" stroke="#F8B200" stroke-width="1.2"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <label class="px-1" *ngIf="activeBot?.webhook_url != null" style="font-family: 'Montserrat';
                            font-style: normal;
                            font-weight: 700;
                            font-size: 14px;
                            line-height: 17px;
                            letter-spacing: 0.2px;
                            color: #35C689;">Active</label>
                        <label class="px-1" *ngIf="activeBot?.webhook_url == null" style="font-family: 'Montserrat';
                            font-style: normal;
                            font-weight: 700;
                            font-size: 14px;
                            line-height: 17px;
                            letter-spacing: 0.2px;
                            color: #DB4F4F;">Inactive</label>
                    </div>

                </mat-card>
            </div>
            <div class="row py-2">
                <mat-card class="py-2 pb-1" style="display: inline-flex;box-shadow: none;">
                    <div class="col-3">
                        <div class="row" >
                            <div class = "col-3">
                                <img [src]="activeBot?.configuration.photo" width="50" height="50" />
                            </div>
                            <div class="col p-2">
                                <label class="field-title">Bot Name & Profile Picture</label>
                                <p class="field-value">{{activeBot?.configuration.name}}</p>
                            </div>
                        </div>
                    </div>
                    <div style="border: 1px solid #eeeeee;height: 90%;"></div>
                    <div class="col-3 py-2 px-4">
                        <label class="field-title">Bot Category</label>
                        <p class="field-value">{{activeBot?.configuration.category}}</p>
                    </div>
                    <div style="border: 1px solid #eeeeee;height: 90%;"></div>
                    <div class="col-3 py-2 px-4">
                        <label class="field-title">Bot ID</label>
                        <p class="field-value">{{activeBot?.bot_id}}</p>
                    </div>
                    <div style="border: 1px solid #eeeeee;height: 90%;"></div>
                    <div class="col-3 py-2 px-4">
                        <label class="field-title">Language supported</label>
                        <p class="field-value">English</p>
                    </div>
                </mat-card>
            </div>
            <div class="row py-2">
                <mat-card style="box-shadow: none;">
                    <label class="field-title py-2">Bot Description </label>
                    <p class="field-value">{{activeBot?.configuration.description}}</p>
                </mat-card>
            </div>
            <div class="row py-2">
                <mat-card style="box-shadow: none;">
                    <label class="field-title py-2">Add labels/tags to this bot for easy discoverability</label>
                    <div class="editor-tag" (click)="focusTagInput()">
                        <span class="tag-item py-1 mr-2" *ngFor="let tag of tags">
                            <span class="pl-2">{{tag}}</span>
                            <span class="remove-tag pl-2" (click)="removeTag(tag)">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="10" cy="10" r="10" fill="white" />
                                    <path
                                        d="M10.9391 9.99943L13.803 7.14179C13.9284 7.01635 13.9989 6.84623 13.9989 6.66884C13.9989 6.49146 13.9284 6.32133 13.803 6.1959C13.6776 6.07047 13.5075 6 13.3301 6C13.1528 6 12.9827 6.07047 12.8572 6.1959L10 9.06021L7.14276 6.1959C7.01735 6.07047 6.84725 6 6.66988 6C6.49252 6 6.32242 6.07047 6.19701 6.1959C6.07159 6.32133 6.00114 6.49146 6.00114 6.66884C6.00114 6.84623 6.07159 7.01635 6.19701 7.14179L9.06091 9.99943L6.19701 12.8571C6.13458 12.919 6.08504 12.9927 6.05122 13.0738C6.01741 13.155 6 13.2421 6 13.33C6 13.418 6.01741 13.505 6.05122 13.5862C6.08504 13.6674 6.13458 13.741 6.19701 13.803C6.25892 13.8654 6.33259 13.915 6.41375 13.9488C6.49491 13.9826 6.58196 14 6.66988 14C6.75781 14 6.84486 13.9826 6.92602 13.9488C7.00718 13.915 7.08085 13.8654 7.14276 13.803L10 10.9387L12.8572 13.803C12.9192 13.8654 12.9928 13.915 13.074 13.9488C13.1551 13.9826 13.2422 14 13.3301 14C13.418 14 13.5051 13.9826 13.5863 13.9488C13.6674 13.915 13.7411 13.8654 13.803 13.803C13.8654 13.741 13.915 13.6674 13.9488 13.5862C13.9826 13.505 14 13.418 14 13.33C14 13.2421 13.9826 13.155 13.9488 13.0738C13.915 12.9927 13.8654 12.919 13.803 12.8571L10.9391 9.99943Z"
                                        fill="#386AF6" stroke="#386AF6" stroke-width="0.5" />
                                </svg>
                            </span>
                        </span>
                        <input #tagInput type="text" class="input-tag" (keyup)="onKeyUp($event)"
                            [(ngModel)]="tagsInput" [ngStyle]="tags.length == 0 && {'width':'50%'}" [placeholder]="tags.length == 0?'Type here to add labels/tags...':''">
                    </div>
                    <p class="text-danger" *ngIf="tags_error!=''">{{tags_error}}</p>
                </mat-card>
            </div>
            <div class="row py-2">
                <mat-card style="box-shadow: none;">
                    <div class="d-flex">
                        <label class="field-title py-2">Location where audiences can search this bot</label>
                        <button (click)="addcountryFormGroup()" class="px-3 py-2" style="font-style: normal;
                        font-weight: 500;
                        font-size: 12px;
                        line-height: 15px;
                        letter-spacing: 0.002em;
                        color: #FFFFFF;
                        background: #386AF6;
                        border: 1px solid #386AF6;    margin-left: auto;
                        border-radius: 8px;font-family: 'Montserrat';
                        ">
                        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.28689 6H1H6.28689Z" fill="white"/>
                            <path d="M5.46335 11C5.46335 11.4548 5.83206 11.8235 6.28689 11.8235C6.74171 11.8235 7.11042 11.4548 7.11042 11H5.46335ZM7.11042 1C7.11042 0.545173 6.74171 0.176463 6.28689 0.176463C5.83206 0.176463 5.46335 0.545173 5.46335 1H7.11042ZM11.5738 6.82354C12.0286 6.82354 12.3973 6.45483 12.3973 6C12.3973 5.54517 12.0286 5.17646 11.5738 5.17646V6.82354ZM1 5.17646C0.545173 5.17646 0.176463 5.54517 0.176463 6C0.176463 6.45483 0.545173 6.82354 1 6.82354V5.17646ZM7.11042 11V6H5.46335V11H7.11042ZM7.11042 6V1H5.46335V6H7.11042ZM6.28689 6.82354H11.5738V5.17646H6.28689V6.82354ZM6.28689 5.17646H1V6.82354H6.28689V5.17646Z" fill="white"/>
                        </svg>    
                        Add Location</button>
                    </div>
                    <div [formGroup]="countryForm">
                        <div formArrayName="countries" class="row">
                        <div *ngFor="let country of countryForm.get('countries')['controls'];let i = index" [formGroupName]="i"
                        [ngStyle]="i%2==0 && {'border-right': '1px solid #ECECEC'}"
                        class="col-6 pb-4">
                            <div >
                                <div class="pt-3 pb-2">
                                    <label class="pr-2" style="border-right: 1px solid #ECECEC;font-family: 'Montserrat';font-style: normal;font-weight: 600;font-size: 12px;line-height: 15px;letter-spacing: 0.2px;color: #0E0E0E;" 
                                    >Location</label>
                                    <a (click)="removeOrClearcountry(i)" class="pl-2 pointer" style="font-family: 'Montserrat';
                                    font-style: normal;
                                    font-weight: 500;
                                    font-size: 12px;
                                    line-height: 15px;
                                    text-align: center;
                                    text-decoration-line: underline;
                                    color: #386AF6;"> Remove </a>
                                </div>
                                <div  class="col-11">
                                    <app-autocomplete class="w-100" formControlName="country" [dropdownId]="'country'+i" [availableTags]="countryList[i]" [placeholder]="'Select country'" (selected)="selectedData($event, i)" [multiple]="false" [refresh]="refresh"></app-autocomplete>
                                    <!-- <div #countryDropdown ngbDropdown placement="bottom-end" class="d-inline-block w-100 res-w-100"
                                        (openChange)="dropdown_country_icon=$event;">
                                        <input type="text" class="focus-border-none country-dropdown pointer" id="dropdownBasic1"
                                        ngbDropdownToggle formControlName="country" placeholder="Select country" style="padding-left: 0px;">
                                        <span class="chevron-align pointer">
                                        <mat-icon style="margin-left: auto;color: #386AF6;" *ngIf="!dropdown_country_icon">keyboard_arrow_down
                                        </mat-icon>
                                        <mat-icon style="margin-left: auto;color: #386AF6;" *ngIf="dropdown_country_icon">keyboard_arrow_up
                                        </mat-icon>
                                        </span>
                                        <div class="px-4" style="transform: translate3d(-25.2px, 53px, 0px)!important;width:100%;border: 1px solid #ECECEC;border-radius: 8px;" ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                            <div class="pointer" *ngFor="let country of filteredCountryList | async;">
                                                <div class="form-check py-3">
                                                <input class="pointer default-radio" type="radio" name="flexRadioDefault" id="flexRadioDefault" [value]="country.name+i"
                                                >
                                                <label class="form-check-label country-font" for="flexRadioDefault1">
                                                    {{country.name}}
                                                </label>
                                                </div>
                                                <div *ngIf="i<countryList.length-1" style="border-bottom: 1px solid #ECECEC;"></div>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                                <div class="col-11" *ngIf="form.controls[i].value.country && form.controls[i].value.country.length > 0">
                                    <div class="pt-3 pb-2">
                                        <label style="font-family: 'Montserrat';
                                                font-style: normal;
                                                font-weight: 500;
                                                font-size: 12px;
                                                line-height: 15px;
                                                letter-spacing: 0.2px;
                                                color: #0E0E0E;
                                                " *ngIf="form.controls[i].value.states.length == 0">Select state, if you want your bot to be searchable only in
                                        <b>particular states</b></label>
                                    </div>
                                    <app-autocomplete class="w-100" formControlName="states" [dropdownId]="'state'+i" [availableTags]="stateList[i]" [placeholder]="'Select States'" (selected)="onStateItemSelect($event, i)" [multiple]="true" [refresh]="refresh"></app-autocomplete>
                                </div>
                                <div class="col-11" *ngIf="form.controls[i].value.states && form.controls[i].value.states.length > 0">
                                    <div class="pt-3 pb-2">
                                        <label style="font-family: 'Montserrat';
                                                font-style: normal;
                                                font-weight: 500;
                                                font-size: 12px;
                                                line-height: 15px;
                                                letter-spacing: 0.2px;
                                                color: #0E0E0E;
                                                " *ngIf="form.controls[i].value.city.length == 0">Select city, if you want your bot to be searchable only in
                                        <b>particular cities</b></label>
                                    </div>
                                    <app-autocomplete class="w-100" formControlName="city" [dropdownId]="'city'+i" [availableTags]="cityList[i]" [placeholder]="'Select city'" (selected)="onCityItemSelect($event, i)" [multiple]="true" [refresh]="refresh"></app-autocomplete>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <label class="field-title py-2">Save Location</label>
                        <button (click)="saveLocation()" class="px-3 py-2" style="font-style: normal;
                        font-weight: 500;
                        font-size: 12px;
                        line-height: 15px;
                        letter-spacing: 0.002em;
                        color: #FFFFFF;
                        background: #386AF6;
                        border: 1px solid #386AF6;    margin-left: auto;
                        border-radius: 8px;font-family: 'Montserrat';
                        ">
                        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.28689 6H1H6.28689Z" fill="white"/>
                            <path d="M5.46335 11C5.46335 11.4548 5.83206 11.8235 6.28689 11.8235C6.74171 11.8235 7.11042 11.4548 7.11042 11H5.46335ZM7.11042 1C7.11042 0.545173 6.74171 0.176463 6.28689 0.176463C5.83206 0.176463 5.46335 0.545173 5.46335 1H7.11042ZM11.5738 6.82354C12.0286 6.82354 12.3973 6.45483 12.3973 6C12.3973 5.54517 12.0286 5.17646 11.5738 5.17646V6.82354ZM1 5.17646C0.545173 5.17646 0.176463 5.54517 0.176463 6C0.176463 6.45483 0.545173 6.82354 1 6.82354V5.17646ZM7.11042 11V6H5.46335V11H7.11042ZM7.11042 6V1H5.46335V6H7.11042ZM6.28689 6.82354H11.5738V5.17646H6.28689V6.82354ZM6.28689 5.17646H1V6.82354H6.28689V5.17646Z" fill="white"/>
                        </svg>    
                        Save Location</button>
                    </div>
                </mat-card>
            </div>
            <div class="row py-2">
                <mat-card style="box-shadow: none;">
                    <label class="field-title py-2">Can this Bot be searchable ?</label>
                    <div class="row px-3">
                        <div class="col-1 form-check">
                            <input value='1' class="default-radio" type="radio" name="flexRadioDefault1" id="flexRadioDefault1" style="margin-top: 0.2rem !important;"
                            (change)="is_searchable = 1" [checked]="(is_searchable == 1) ? true : false">
                            <label class="form-check-label" for="flexRadioDefault1" style="font-family: 'Montserrat';
                            font-style: normal;
                            font-weight: 500;
                            font-size: 14px;
                            display: flex;
                            align-items: center;
                            letter-spacing: 0.002em;
                            color: #0E0E0E;">
                                Yes
                            </label>
                        </div>
                        <div class="col-1 form-check">
                            <input value='0' class="default-radio" type="radio" name="flexRadioDefault1" id="flexRadioDefault2" style="margin-top: 0.2rem !important;"
                            (change)="is_searchable = 0" [checked]="(is_searchable == 0) ? true : false">
                            <label class="form-check-label" for="flexRadioDefault2" style="font-family: 'Montserrat';
                            font-style: normal;
                            font-weight: 500;
                            font-size: 14px;
                            display: flex;
                            align-items: center;
                            letter-spacing: 0.002em;
                            color: #0E0E0E;">
                                No
                            </label>
                        </div>
                    </div>
                </mat-card>
            </div>
            <div class="row py-2">
                <mat-card style="box-shadow: none;">
                    <label class="field-title py-2">Can this Bot be displayed on Bot Store page?</label>
                    <div class="row px-3">
                        <div class="col-1 form-check">
                            <input value='1' class="default-radio" type="radio" name="flexRadioDefault" id="flexRadioDefault1" style="margin-top: 0.2rem !important;"
                            (change)="is_discoverable = 1" [checked]="(is_discoverable == 1) ? true : false">
                            <label class="form-check-label" for="flexRadioDefault1" style="font-family: 'Montserrat';
                            font-style: normal;
                            font-weight: 500;
                            font-size: 14px;
                            display: flex;
                            align-items: center;
                            letter-spacing: 0.002em;
                            color: #0E0E0E;">
                                Yes
                            </label>
                        </div>
                        <div class="col-1 form-check">
                            <input value='0' class="default-radio" type="radio" name="flexRadioDefault" id="flexRadioDefault2" style="margin-top: 0.2rem !important;"
                            (change)="is_discoverable = 0" [checked]="(is_discoverable == 0) ? true : false">
                            <label class="form-check-label" for="flexRadioDefault2" style="font-family: 'Montserrat';
                            font-style: normal;
                            font-weight: 500;
                            font-size: 14px;
                            display: flex;
                            align-items: center;
                            letter-spacing: 0.002em;
                            color: #0E0E0E;">
                                No
                            </label>
                        </div>
                    </div>
                </mat-card>
            </div>
            <div class="row py-2">
                <mat-card style="box-shadow: none;">
                    <div class="row px-2">
                    <div class="form-group form-check col-8">
                        <input type="checkbox" class="form-check-input" id="exampleCheck1">
                        <label style="font-family: 'Montserrat';
                            font-style: normal;
                            font-weight: 500;
                            font-size: 12px;
                            line-height: 130%;
                            letter-spacing: 0.2px;
                            color: #000000;">
                        I have verified the bot’s name, profile picture, description and welcome banner</label>
                    </div>

                    <div class="col" style = "text-align:right">
                        <button class ="mx-1" (click)="verifyBot()" style="font-family: 'Montserrat';
                        font-style: normal;
                        font-size: 14px;
                        line-height: 30px;
                        width: 99px;
                        align-items: center;
                        color: #35C689;
                        background: none;
                        border: 1px solid #35C689;
                        border-radius: 12px;">Approve</button>
                        <button  class ="mx-1" (click)="verifyBot()" style="font-family: 'Montserrat';
                        font-style: normal;
                        width: 99px;
                        font-size: 14px;
                        line-height: 30px;
                        align-items: center;
                        color: #EB5757;
                        background: none;
                        border: 1px solid #DB4F4F;
                        border-radius: 12px;">Reject</button>

                    </div>
                    </div>

                </mat-card>
            </div>
        </div>
    </div>
</div>